import { type ComponentProps } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { type Edges, SafeAreaView } from 'react-native-safe-area-context';

import { pointerEventsStyles, Button, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsButton = (props: Props) => {
  const { minWidth } = useResponsive();

  // ─────────────────────────────────────────────────────────────────────

  if (minWidth.isSM) {
    return <Button palette="primary" style={styles.buttonSM} {...props} />;
  }

  // ─────────────────────────────────────────────────────────────────────

  return (
    <SafeAreaView
      edges={SAFE_AREA_EDGES}
      style={[styles.outerContainerXS, pointerEventsStyles['box-none']]}
    >
      <View style={styles.containerXS}>
        <Button palette="primary" size="large-wide" style={styles.buttonXS} {...props} />
      </View>
    </SafeAreaView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SAFE_AREA_EDGES: Edges = Platform.select({
  android: ['bottom'],
  default: [],
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainerXS: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
  },
  containerXS: {
    paddingTop: theme.spacing['6'],
    paddingHorizontal: theme.spacing['6'],
    paddingBottom: theme.spacing['5'],
  },
  buttonXS: {
    minWidth: 100,
    ...theme.elevations[6],
  },
  buttonSM: {
    minWidth: 100,
    alignSelf: 'flex-start',
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<ComponentProps<typeof Button>, 'style'>;
